import React from "react";
import { Download, Search } from "lucide-react";
import { API } from "../../lib/api";
import { STATUS_OPTIONS } from "../../hooks/useLeads";

export const LeadsToolbar = ({ count, filter, setFilter, statusFilter, setStatusFilter }) => (
  <>
    <header className="flex items-end justify-between flex-wrap gap-4 mb-8">
      <div>
        <div className="font-display text-[11px] uppercase tracking-[0.3em] text-[#0A192F]/60">
          Inbox
        </div>
        <h1 className="mt-2 font-display font-black text-4xl text-[#0A192F] tracking-tighter">
          Leads ({count})
        </h1>
      </div>
      <a
        href={`${API}/admin/leads/export`}
        download
        data-testid="admin-leads-export"
        className="inline-flex items-center gap-2 border border-[#0A192F] text-[#0A192F] px-5 py-3 font-display text-xs uppercase tracking-[0.25em] font-bold hover:bg-[#0A192F] hover:text-white transition-colors"
      >
        <Download size={14} /> Export CSV
      </a>
    </header>

    <div className="flex flex-wrap gap-3 mb-6">
      <div className="relative flex-1 min-w-[240px]">
        <Search
          size={14}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-[#0A192F]/40"
        />
        <input
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          placeholder="Search leads…"
          data-testid="admin-leads-search"
          className="w-full pl-9 pr-4 py-2.5 bg-white border border-gray-300 text-sm focus:border-[#D4AF37] focus:outline-none"
        />
      </div>
      <select
        value={statusFilter}
        onChange={(e) => setStatusFilter(e.target.value)}
        data-testid="admin-leads-status-filter"
        className="bg-white border border-gray-300 px-4 py-2.5 text-sm focus:border-[#D4AF37] focus:outline-none"
      >
        <option value="all">All statuses</option>
        {STATUS_OPTIONS.map((s) => (
          <option key={s.v} value={s.v}>
            {s.label}
          </option>
        ))}
      </select>
    </div>
  </>
);

export default LeadsToolbar;
